import { http } from '@pendo/http';

export function getPullSyncProviderIntegrations () {
    return http.get('/api/s/_SID_/integration/sync/pull');
}

export function createPullSyncProviderIntegration (payload) {
    return http.post('/api/s/_SID_/integration/sync/pull', payload);
}

export function getPullSyncProviderIntegrationById (rootVersionId) {
    return http.get(`/api/s/_SID_/integration/sync/pull/${rootVersionId}`);
}

export function getProviderMetadataById (id, providerName) {
    return http.get(`/api/s/_SID_/integration/sync/pull/${id}/${providerName}/metadatatranslation`);
}

export function updatePullSyncProviderJoinField (rootVersionId, joinField) {
    return http.put(`/api/s/_SID_/integration/sync/pull/${rootVersionId}`, { joinField });
}

export function runPullSyncProviderJob (rootVersionId) {
    return http.post(`/api/s/_SID_/integration/sync/pull/${rootVersionId}/run`, {});
}

export function getPullSyncProviderJobStatus (rootVersionId) {
    return http.get(`/api/s/_SID_/integration/sync/pull/${rootVersionId}/status`);
}
